/* eslint-disable @typescript-eslint/camelcase */
/* globals $ */
import intl from 'react-intl-universal'

import CONSTANTS from '~/constants'
class EllipsisError extends Error {
  constructor(props) {
    super()
    for (const p in props) {
      this[p] = props[p]
    }
  }
}

// this needs to return entire object, not just id
function reduceByUniqueId(collection = [], toAdd) {
  const ids = collection.map((item) => item._id)
  const reduction = [...collection, ...toAdd].reduce((acc, item) => {
    const list = ids.indexOf(item._id) > -1 ? acc : [...acc, item]
    ids.push(item._id)
    return list
  }, [])
  return reduction
}

function setRelatedContentGroups(collection = { basic: [] }) {
  const reduction = (collection.basic || []).reduce((acc, item) => {
    if (item.type) {
      acc[item.type] = acc[item.type] ? [...acc[item.type], item] : [item]
    }
    return acc
  }, {})
  return reduction
}

function thirdPartyIntegration(api, key, onCancel, onSelect, $q, storyService) {
  const deferred = $q.defer()
  let dialogElem = $('#dialog-thirdParty')

  if (!dialogElem.length) {
    const template = `
      <div id='dialog-thirdParty' title=''>
        <iframe id='dialog-thirdParty-iframe'></iframe>
      </div>
    `
    dialogElem = $(template).appendTo(document.body)
  }

  const ifr = $('#dialog-thirdParty-iframe').attr('src', api)

  $('#dialog-thirdParty').dialog({
    dialogClass: 'removeTitle',
    resizable: false,
    height: $(window).height() - 100,
    width: $(window).width() - 100,
    modal: true,
    buttons: {
      Cancel: {
        click: function () {
          $(this).dialog('close')
          // this has to clear all the related items
          // of whatever type we are looking at
          onCancel(key)
          deferred.reject()
        },
        text: 'cancel',
        class: 'btn',
      },
      Select: {
        click: function () {
          setTimeout(() => {
            $(this).dialog('close')
          }, 500)
          // this one is for same origin ellipsis search results
          window.parent.postMessage('returnSelectedANS', window.location.origin)
          // this one is for cors angler/goldfish
          ifr
            .get(0)
            .contentWindow.postMessage(
              'returnSelectedANS',
              window.location.origin
            )

          storyService.isDirty(true)
        },
        text: 'Select',
        class: 'btn btn-success',
      },
    },
    close: function () {
      $('#dialog-thirdParty').remove()
    },
  })

  return deferred.promise
}

function bindDraggable($rootScope) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const self = this

  $('#related-items-container').draggable({
    connectToSortable: '#story-wrapper',
    appendTo: '#story-wrapper',
    forceHelperSize: true,
    handle: 'div.collapse.show div.group-item',
    scroll: false,
    cursorAt: { top: 0, right: 0 },
    start: function (event) {
      const $draggedRelatedItem = $(event.originalEvent.target)
      const idForDraggedRI = $draggedRelatedItem.data('_id')
      const typeForDraggedRI = $draggedRelatedItem.data('type')

      const relatedItems = self.relatedContentGroups[typeForDraggedRI]
      const selectedRI = relatedItems.find(function (ri) {
        return ri._id === idForDraggedRI
      })

      $rootScope.$broadcast('RELATED_ITEMS_DRAG_START', {
        draggedRelatedItem: selectedRI,
      })
    },
    helper: function (evt) {
      const relatedItemElem = $(evt.target)

      const type = relatedItemElem.data('type')

      const elems = $('<div/>')
      elems.append(relatedItemElem.clone())

      return $(
        '<p data-context="related-element" data-type="' +
          type +
          '" data-refid="' +
          relatedItemElem.data('context') +
          '" class="temp helper drag-view"></p>'
      )
        .append(elems)
        .height('100px')
        .width('200px')
    },
    revert: true,
    revertDuration: 0,
  })
}

function relatedItemsController(
  toastr,
  contentApi,
  storyService,
  $q,
  $rootScope,
  contentTemplatesService
) {
  this.$onInit = () => {
    this.related_content = this.storyObj.related_content
    this.relatedContentGroups = setRelatedContentGroups(this.related_content)
    bindDraggable.call(this, $rootScope)
  }

  const listen = (data) => {
    // filter out items we already have in basic
    const items = reduceByUniqueId(
      (this.related_content || { basic: [] }).basic,
      Array.isArray(data) ? data : [data]
    )
    items.forEach((item) => {
      if (item.type === 'video') {
        $('#dialog-thirdParty').dialog('close')
      }
      if (typeof item === 'string') {
        throw new EllipsisError({
          message: 'related item cannot be string, must follow ans spec',
          item,
        })
      }
      if (!item._id) {
        throw new EllipsisError({
          message: 'related item must have _id property',
          item,
        })
      }
    })

    const rc = {
      ...this.related_content,
      // add what we already have in basic + selected items that are not in basic
      basic: [...(this.related_content || { basic: [] }).basic, ...items],
    }

    storyService.setStoryProp('related_content', rc)
    console.log('setting', rc)

    // mutate list to hash for the view
    this.relatedContentGroups = setRelatedContentGroups(rc)
    this.related_content = rc

    this.activeItem = null
  }

  // to get list of stories in current search state
  // need to cache search state in a service and get here
  // query string will default to nothing if user
  // navigates to /story without querying anything first
  const urls = {
    story: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/search`,
    image: '/photo/selector/?select=multiple',
    gallery: '/photo/galleries/selector/?select=multiple',
    video: '/videocenter/plugins/videosearch/',
  }

  const msgListener = (e) => {
    const data = e.originalEvent.data || []

    if (!this.activeItem || data === 'returnSelectedANS') {
      return
    }

    const temp = Array.isArray(data) ? data : [data]
    const hasTypes = temp.every((itm) => itm && itm.type)

    if (!hasTypes) {
      return
    }

    $(window).off('message.rc', msgListener)

    try {
      listen(data)
    } catch (e) {
      if (e instanceof EllipsisError) {
        console.warn('bad related item', e.message, e.item)
        return toastr.error(intl.get('relatedItems.msgListener.invalid'))
      }
      console.log(data, e.stack)
      toastr.error(intl.get('relatedItems.msgListener.error'))
    }
  }

  this.preview = (item) => {
    let url = item.canonical_url || item.additional_properties.proxyUrl
    if (item.type === 'story') {
      url = `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/story/${item._id}/`
    }
    window.open(url, '_blank')
  }

  this.edit = (item) => {
    const url = contentTemplatesService.getPreview(item.type)(item)
    if (url) {
      window.open(url, '_blank')
    }
  }

  // basic must exist at this point
  this.delete = (id) => {
    this.related_content.basic = this.related_content.basic.filter(
      (i) => i._id !== id
    )
    this.relatedContentGroups = setRelatedContentGroups(this.related_content)
  }

  this.selectRelated = () => {
    // undefined selectedItems: selectedItems[key] = []
  }

  this.cancelRelated = () => {
    this.activeItem = null
    $(window).off('message.rc', msgListener)
    // do something when user cancels iframe
  }

  this.addRelatedContent = (type) => {
    $(window).on('message.rc', msgListener)
    this.activeItem = type
    thirdPartyIntegration(
      urls[type],
      type,
      this.cancelRelated,
      this.selectRelated,
      $q,
      storyService
    ).then(
      (ans) => {
        this.related_content.basic.push(ans)
        this.relatedContentGroups = setRelatedContentGroups(
          this.related_content
        )
      },
      () => {
        // did not select
      }
    )
  }

  // $rootScope.$on('SAVE_SUCCESS', (evt, data) => {
  //  this.story = data.story
  // })
}

export default [
  'toastr',
  'contentApiService',
  'storyService',
  '$q',
  '$rootScope',
  'contentTemplatesService',
  relatedItemsController,
]
